<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <el-dialog
      class="newDialog"
      title="快速加入好友群組"
      :visible.sync="visible"
      height="100%"
      :before-close="handleClose"
    >
      <div class="newList">
        <ul style="margin-top: 0px; border-top-width: 0px;">
          <li
            v-for="(item,index) in groupList "
            v-show="item.GroupSysType=='' || item.GroupSysType=='favorite' || item.GroupSysType=='unknownmotivation'"
          >
            <label :for="item.Id" @click="choiseFriendGroup(item)" style="width:100%;">
              <img
                class="group-img"
                v-bind:src="item.FriendGroupPhotoURL"
                alt
                style="width: 60px;vertical-align:middle"
                :class="SelectClass(item)"
              />
              <div style="width: calc(100% - 115px); display: inline-block; padding-left: 10px;">
                <h3 style="font-size: 17px; color: #676767;">{{item.GroupName}}</h3>
              </div>
            </label>
          </li>
        </ul>
        <br />
        <span v-if="groupList.length == 0">沒有好友群組</span>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import Global from "@/components/Global";
import { FriendGroupHandler } from "../../handler/FriendGroup.js";
import { FriendListHandler } from "../../handler/FriendListHandler.js";
export default {
  name: "QuicklyJoinFriendGroup",
  props: ["roomInfo", "staffInfo"],
  data() {
    return {
      fullscreenLoading: false,
      visible: false,
      groupList: []
    };
  },
  created() {},
  methods: {
    // 開啟視窗
    openFriendGroupList: function() {
      this.visible = true;
      this.fullscreenLoading = true;
      this.staff = this.GetLoginStaff();
      this.groupList = FriendGroupHandler.GetGroup(this.staff.staffid);
      this.groupList = this.groupList.splice(3, this.groupList.length - 3);
      this.fullscreenLoading = false;
    },
    handleClose(done) {
      this.visible = false;
    },
    choiseFriendGroup(group) {
      this.visible = false;
      if (
        this.CheckSocialLeadIdInGroup(
          group.FriendGroupItem,
          this.roomInfo.SocialLeadId
        )
      ) {
        FriendListHandler.DeleteFriendGroupItem(
          this.roomInfo.SocialLeadId,
          group.Id,
          this.staff.staffid
        );
        this.ShowNotice(
          "客戶" +
            this.roomInfo.LeadCname +
            "已成功從" +
            group.GroupName +
            "好友群組中刪除"
        );
      } else {
        FriendListHandler.AddFriendGroupItem(
          this.roomInfo.SocialLeadId,
          group.Id,
          this.staff.staffid
        );
        this.ShowNotice(
          "客戶" +
            this.roomInfo.LeadCname +
            "已成功加入" +
            group.GroupName +
            "好友群組"
        );
      }
    },
    SelectClass(group) {
      if (
        this.CheckSocialLeadIdInGroup(
          group.FriendGroupItem,
          this.roomInfo.SocialLeadId
        )
      ) {
        return "";
      } else {
        return "gray";
      }
    },
    CheckSocialLeadIdInGroup(friendGroupItems, socialLeadId) {
      var result = $.map(friendGroupItems, function(item, index) {
        return item.SocialLeadId;
      }).indexOf(socialLeadId);
      if (result == -1) {
        return false;
      } else {
        return true;
      }
    },
    ShowNotice(msg) {
      this.$notify({
        title: "成功",
        message: msg,
        type: "success",
        position: "top-left"
      });
    }
  }
};
</script> 

<style>
.gray {
  -webkit-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
  filter: alpha(opacity = 30);
  opacity: 0.3;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/ChatToolBar_QuicklyJoinFriendGroup.vue